import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { H2, H6 } from '@luigiclaudio/ga-baseline-ui/typography';
import ColorModalTitleContainer from './ColorModalTitleContainer';
import colorToolsUtils from '../../../utils/colorToolsUtils';
import ColorNameLicense from '../../ColorNameLicense';

const ColorModalTitle = ({ colorValue, subtitle }) => {
    const renderColorName = useMemo(
        () => colorToolsUtils.colorName(colorValue.slice(1)),
        [colorValue],
    );

    return (
        <ColorModalTitleContainer>
            {subtitle && <H6 color="muted">{subtitle}</H6>}
            <H2>
                <ColorNameLicense>{renderColorName}</ColorNameLicense>
            </H2>
        </ColorModalTitleContainer>
    );
};

ColorModalTitle.propTypes = {
    colorValue: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
};

ColorModalTitle.defaultProps = {
    subtitle: undefined,
};

export default ColorModalTitle;
